import { SITE_NAME } from "../config/seoMeta";

function setMetaByName(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setMetaByProperty(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function removeMetaByProperty(property) {
  document.querySelector(`meta[property="${property}"]`)?.remove();
}

function removeMetaByName(name) {
  document.querySelector(`meta[name="${name}"]`)?.remove();
}

function setCanonicalLinkHref(href) {
  if (!href) return;
  let link = document.getElementById("wz-canonical");
  if (!link) {
    link = document.querySelector('link[rel="canonical"]');
  }
  const links = document.querySelectorAll('link[rel="canonical"]');
  links.forEach((node) => {
    if (node !== link) node.remove();
  });
  if (!link) {
    link = document.createElement("link");
    link.id = "wz-canonical";
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

/**
 * Updates document title and core meta tags (description, Open Graph, Twitter).
 * @param {{ title: string, description: string, robots?: string, canonicalHref?: string, ogImage?: string }} opts
 */
export function applySeoToDocument({
  title,
  description,
  robots = "index, follow",
  canonicalHref = "",
  ogImage = "",
}) {
  document.title = title;

  setMetaByName("description", description);

  setMetaByProperty("og:title", title);
  setMetaByProperty("og:description", description);
  setMetaByProperty("og:type", "website");
  setMetaByProperty("og:site_name", SITE_NAME);

  if (ogImage) {
    setMetaByProperty("og:image", ogImage);
    setMetaByName("twitter:image", ogImage);
  } else {
    removeMetaByProperty("og:image");
    removeMetaByName("twitter:image");
  }

  if (canonicalHref) {
    setMetaByProperty("og:url", canonicalHref);
    setMetaByName("twitter:url", canonicalHref);
    setCanonicalLinkHref(canonicalHref);
  } else {
    removeMetaByProperty("og:url");
    removeMetaByName("twitter:url");
    document.querySelectorAll('link[rel="canonical"]').forEach((el) => el.remove());
  }

  setMetaByName("twitter:card", "summary_large_image");
  setMetaByName("twitter:title", title);
  setMetaByName("twitter:description", description);

  setMetaByName("robots", robots || "index, follow");
}
